<template>
    <el-card shadow="hover" class="review-workbench-entry-card">
        <div class="review-workbench-entry-card__header">
            <div>
                <div class="review-workbench-entry-card__title">{{ title }}</div>
                <div class="review-workbench-entry-card__summary">{{ summary }}</div>
            </div>
            <el-tag
                v-if="statusText"
                size="mini"
                :type="statusType"
            >
                {{ statusText }}
            </el-tag>
        </div>
        <div class="review-workbench-entry-card__body">
            <div class="review-workbench-entry-card__description">
                {{ description }}
            </div>
            <slot />
        </div>
        <div class="review-workbench-entry-card__footer">
            <el-button type="primary" size="mini" @click="$emit('enter')">
                进入核验
            </el-button>
        </div>
    </el-card>
</template>

<script>
export default {
    name: "ReviewWorkbenchEntryCard",
    props: {
        title: {
            type: String,
            default: "",
        },
        summary: {
            type: String,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
        statusText: {
            type: String,
            default: "",
        },
        statusType: {
            type: String,
            default: "info",
        },
    },
};
</script>

<style scoped>
.review-workbench-entry-card {
    border-radius: 16px;
    min-height: 100%;
}

.review-workbench-entry-card__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
}

.review-workbench-entry-card__title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2d3d;
}

.review-workbench-entry-card__summary {
    margin-top: 6px;
    color: #7a8499;
    font-size: 13px;
}

.review-workbench-entry-card__body {
    min-height: 92px;
}

.review-workbench-entry-card__description {
    color: #4f5d75;
    line-height: 1.7;
    font-size: 14px;
}

.review-workbench-entry-card__footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}
</style>
